const state = {
    
    blocks:[
        {
            id:1,
            name:'',
            color:'#fff',
            columns:1,
            blockcomponents: {
                columns: [
                    //left column
                    [
                        {
                            id:1,
                            name:'forminputfield',
                            attributes:{
                                    placeholder:"Text",
                                    size:"xs10",
                                    invertedsize:"xs1",
                                    hint:"Bitte den Text eingeben",
                                    icon:"edit",
                                    variable: 'text',
                                    setter: 'preparations/PREPARATION_SET_TEXT',
                                    rules:"required"                                    
                            }
                        },
                                                                      
                    ],                   
                    [
                       
                                                                    
                        
                    ],                   
                ]
            }
        }
    ]

};

export default {
  namespaced: false,
  state,
  
};